import type { FC } from "react";

import { router } from "../bootstrap/router.ts";

import { AuthCallback } from "./AuthCallback.tsx";
import { Dashboard } from "./Dashboard.tsx";
import { Generations } from "./Generations.tsx";
import { GithubConnections } from "./GithubConnections.tsx";
import { GithubConnectionsCallback } from "./GithubConnectionsCallback.tsx";
import { Media } from "./Media.tsx";
import { MemoryProject } from "./MemoryProject.tsx";
import { MemoryProjectComments } from "./MemoryProjectComments.tsx";
import { MemoryProjects } from "./MemoryProjects.tsx";
import { OAuthConsent } from "./OAuthConsent.tsx";
import { Signin } from "./Signin.tsx";

type RouteTag = "nav" | "unauthenticated";

interface Route {
  readonly Component: FC;
  readonly label: string;
  readonly path: string;
  readonly tags?: readonly RouteTag[];
}

const routes: readonly Route[] = [
  {
    Component: Dashboard,
    label: "Dashboard",
    path: router.getPattern("Dashboard"),
    tags: ["nav"],
  },
  {
    Component: Generations,
    label: "Generations",
    path: router.getPattern("Generations"),
    tags: ["nav"],
  },
  {
    Component: Media,
    label: "Media",
    path: router.getPattern("Media"),
    tags: ["nav"],
  },
  {
    Component: GithubConnections,
    label: "GitHub",
    path: router.getPattern("GithubConnections"),
    tags: ["nav"],
  },
  {
    Component: GithubConnectionsCallback,
    label: "GitHub connections callback",
    path: router.getPattern("GithubConnectionsCallback"),
  },
  {
    Component: MemoryProjects,
    label: "Memory",
    path: router.getPattern("MemoryProjects"),
    tags: ["nav"],
  },
  {
    Component: MemoryProject,
    label: "Memory project",
    path: router.getPattern("MemoryProject"),
  },
  {
    Component: MemoryProjectComments,
    label: "Memory project comments",
    path: router.getPattern("MemoryProjectComments"),
  },
  {
    Component: OAuthConsent,
    label: "Authorize an application",
    path: router.getPattern("OAuthConsent"),
  },
  {
    Component: Signin,
    label: "Signin",
    path: router.getPattern("Signin"),
    tags: ["unauthenticated"],
  },
  {
    Component: AuthCallback,
    label: "Auth",
    path: router.getPattern("AuthCallback"),
    tags: ["unauthenticated"],
  },
];

export const navRoutes = routes.filter(isNav);

export const authenticatedRoutes = routes.filter(isAuthenticated);

export const unauthenticatedRoutes = routes.filter(isUnauthenticated);

function isAuthenticated(route: Route): boolean {
  return !isUnauthenticated(route);
}

function isNav(route: Route): boolean {
  return route.tags?.includes("nav") ?? false;
}

function isUnauthenticated(route: Route): boolean {
  return route.tags?.includes("unauthenticated") ?? false;
}
